// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"227":"d6843558","231":"7fd27407","458":"8e3217f7","817":"e56b8217"}[chunkId] + ".css";
};